import { render, staticRenderFns } from "./DogRegistrationIndividualKennelNameUsageSignature.vue?vue&type=template&id=1407e176"
import script from "./DogRegistrationIndividualKennelNameUsageSignature.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualKennelNameUsageSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports